import { defineMessages } from 'react-intl';

export const bucklesMessages = defineMessages({
  tangTypeTitle: {
    defaultMessage: 'Tang-Type Buckle',
    id: `buckle.TangType.title`,
  },
  tangTypeDescription: {
    defaultMessage:
      'SHORT STRAND PLACED AT 12 O’CLOCK, LONG STRAND PLACED AT 6 O’CLOCK',
    id: `buckle.TangType.description`,
  },
  doubleTangTypeTitle: {
    defaultMessage: 'Double Tang-Type Buckle',
    id: 'buckle.doubleTang.title',
  },
  doubleTangTypeDescription: {
    defaultMessage:
      'SHORT STRAND PLACED AT 12 O’CLOCK, LONG STRAND PLACED AT 6 O’CLOCK',
    id: 'buckle.doubleTang.description',
  },

  foldingTitle: {
    defaultMessage: 'Folding Buckle',
    id: 'buckle.folding.title',
  },
  foldingDescription: {
    defaultMessage:
      'SHORT STRAND PLACED AT 6 O’CLOCK / LONG STRAND PLACED AT 12 O’CLOCK',
    id: 'buckle.folding.description',
  },

  pushButtonFoldingClaspTitle: {
    defaultMessage: 'PUSH-BUTTON FOLDING CLASP',
    id: 'buckle.pushButtonFoldingClasp.title',
  },
  pushButtonFoldingClaspDescription: {
    defaultMessage:
      'PLACE THE PART OF THE STRAP HOLDING THE PUSH-BUTTON PART OF THE FOLDING CLASP AT 12 O’CLOCK.',
    id: 'buckle.pushButtonFoldingClasp.description',
  },
  elegant: {
    defaultMessage: 'Elegant',
    id: 'buckle.elegant',
  },
  sporty: {
    defaultMessage: 'Sporty',
    id: 'buckle.sporty',
  },
});
